import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Mail16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.4375 2.25C0.816565 2.25 0.25 2.73827 0.25 3.41667V12.5833C0.25 13.2617 0.816565 13.75 1.4375 13.75H14.5625C15.1834 13.75 15.75 13.2617 15.75 12.5833V3.41667C15.75 2.73827 15.1834 2.25 14.5625 2.25H1.4375ZM1.75 5.54312V12.25H14.25V5.54311L7.99999 10.4538L1.75 5.54312ZM14.1042 3.75H1.89573L7.99999 8.54621L14.1042 3.75Z'
      fill='currentColor'
    />
  </Svg>
);

Mail16.displayName = 'Mail16';
export default Mail16;
